import { FLOWLYTICS_ANALYTICS_LANDING_PAGE_TEST } from '../../../../../analytics/src/constants/optimizely'
import { useFlowExperiment } from '@dtx-company/inter-app/src/hooks/useFlowExperiment/useFlowExperiment'

export const useShowFlowlyticsLandingPage = (): boolean => {
  const [variant] = useFlowExperiment(FLOWLYTICS_ANALYTICS_LANDING_PAGE_TEST, {
    autoUpdate: true
  })
  const shouldShowAnalyticsLandingPage = variant === 'show_analytics_landing_page'
  return shouldShowAnalyticsLandingPage
}
